import { render } from "./CentresInteret.vue?vue&type=template&id=6c4bec8f&scoped=true"
import script from "./CentresInteret.vue?vue&type=script&lang=js"
export * from "./CentresInteret.vue?vue&type=script&lang=js"

import "./CentresInteret.vue?vue&type=style&index=0&id=6c4bec8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4bec8f"]])

export default __exports__